import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from '../../../shared/notification.service';
import { FinancialAccount } from '../accounts';
import { FinancialAccountsService } from '../accounts.service';

@Component({
  selector: 'app-financial-accounts-create',
  templateUrl: 'create.component.html',
})
export class FinancialAccountsCreateComponent implements OnInit {
  /**
   * Details of the financialAccounts being created.
   */
  public financialAccounts: FinancialAccount;

  /**
   * Are we currently performing a loading action?
   *
   * @type {boolean}
   */
  public isLoading: boolean = false;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {AccountsService} financialAccountsService
   * @param {NotificationService} notificationService
   * @param {Router} router
   */
  constructor(
    private financialAccountsService: FinancialAccountsService,
    private notificationService: NotificationService,
    private router: Router,
  ) {
    this.financialAccountsService.loading.subscribe(
      result => (this.isLoading = result),
    );
  }

  /**
   * Initialise the component, creating a new blank financialAccounts if required.
   */
  public ngOnInit(): void {
    if (!this.financialAccounts) {
      this.financialAccounts = new FinancialAccount();
    }
  }

  /**
   * Perform the create action which adds the new financialAccounts into the backend.
   */
  public create() {
    const createFinancialAccounts = this.financialAccountsService
      .createFinancialAccounts(this.financialAccounts)
      .subscribe(
        (result: FinancialAccount) => {
          this.notificationService.success(
            `FinancialAccounts Created`,
            `New financialAccounts ${result.name} has been created with ID of ${
              result.id
            }.`,
            5,
          );
          this.financialAccounts = new FinancialAccount();
          createFinancialAccounts.unsubscribe();
          this.router.navigate(['/financial-accounts']);
        },
        err => {
          this.notificationService.error(
            `Could not create FinancialAccounts`,
            err.error.message,
            10,
          );
        },
      );
  }
}
